import React from 'react';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tab, Tabs } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  supportTable: {
    '& .MuiTableCell-root': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-head': {
      color: theme.palette.primary.gray,
    },
    '& .MuiTableCell-paddingNone': {
      color: theme.palette.primary.mainBlue,
      fontWeight: 'bold',
    },
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
    },
    '& .MuiTableRow-root': {
      '&:hover': {
        backgroundColor: theme.palette.custom.tableRowHover,
      },
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.custom.tableRowHover,
    },
  },
  tag: {
    borderRadius: '5px',
    padding: '5px 8px',
    maxWidth: '160px',
    margin: '0px auto',
  },
  // Same light values the `secondary.*` pairs had; those keys are inherited
  // verbatim in dark mode, which left pastel fills glowing on a dark surface.
  tagOpen: {
    color: theme.palette.custom.statusOpenText,
    backgroundColor: theme.palette.custom.statusOpenBackground,
  },
  tagWaitinfForApproval: {
    color: theme.palette.custom.statusClosedText,
    backgroundColor: theme.palette.custom.statusClosedBackground,
  },
  tagApproved: {
    color: theme.palette.custom.statusApprovedText,
    backgroundColor: theme.palette.custom.statusApprovedBackground,
  },
  tagProcessing: {
    color: theme.palette.custom.statusNeutralText,
    backgroundColor: theme.palette.custom.statusNeutralBackground,
  },
  tagClose: {
    color: theme.palette.custom.statusRejectedText,
    backgroundColor: theme.palette.custom.statusRejectedBackground,
  },
  tagRejected: {
    color: theme.palette.custom.statusPendingText,
    backgroundColor: theme.palette.custom.statusPendingBackground,
  },
  tagPendingDate: {
    color: theme.palette.custom.statusIdleText,
    backgroundColor: theme.palette.custom.statusIdleBackground,
  },
  tagNA: {
    color: theme.palette.custom.statusIdleText,
    backgroundColor: theme.palette.custom.statusIdleBackground,
  },
  iconsCell: {
    '& svg': {
      color: theme.palette.primary.main,
    },
    '& svg:hover': {
      color: theme.palette.primary.blue,
    },
  },
  iconButton: {
    display: 'table-cell',
    textAlign: 'center',
    '& svg': {
      size: 'large',
      color: theme.palette.primary.main,
    },
  },
  roleCells: {
    fontSize: '11px',
  },
  title: {
    flexGrow: 1,
    letterSpacing: '-0.5px',
  },
  input: {
    display: 'none',
  },
  toolbarTable: {
    paddingLeft: '0px',
    justifyContent: 'space-between',
  },
  searchToolbar: {
    '& .MuiOutlinedInput-root': {
      height: '35px',
      fontSize: '13px',
      width: '100vh',
      flexGrow: 1,
    },
    '& .Mui-focused': {
      border: `1px solid ${theme.palette.secondary.gray}`,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.gray,
    },
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '2px',
    },
    '& button': {
      backgroundColor: theme.palette.primary.white,
      color: theme.palette.secondary.gray,
      fontSize: '13.5px',
      '& svg': {
        color: theme.palette.secondary.gray,
      },
    },
    '& .MuiMenuItem-root': {
      color: theme.palette.custom.menuItemText,
    },
  },
  popper: {
    zIndex: 2,
    width: '110px',
    '& ul': {
      paddingBottom: '0px',
    },
  },
  titleOption: {
    borderBottom: `1px solid ${theme.palette.secondary.gray}`,
  },
  roleOption: {
    fontSize: '12px',
  },
  activeOption: {
    fontSize: '13.5px',
  },
  clearOption: {
    fontSize: '13.5px',
    borderTop: `1px solid ${theme.palette.secondary.gray}`,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
    '& svg': {
      color: theme.palette.custom.dangerIcon,
      margin: '0px',
    },
    '& svg:hover': {
      opacity: '0.8',
    },
  },
  progress: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& div': {
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  gridRight: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  userInfo: {
    display: 'grid',
    gridTemplateColumns: '45% 45%',
    columnGap: '5%',
    padding: '30px',
    '& .MuiFormLabel-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiFormControl-root': {
      margin: '10px auto',
    },
    '& input': {
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
  },
  itemList: {
    fontSize: '13.5px',
    color: theme.palette.custom.menuItemText,
  },
  formWrapper: {
    width: '50vw',
    padding: '56px',
    paddingTop: '10px',
    '& .MuiFormLabel-root': {
      color: theme.palette.custom.inputLabel,
      margin: '15px auto 8px',
      fontSize: '12px',
    },
    '& input': {
      backgroundColor: theme.palette.custom.inputBackground,
      padding: '10px',
    },
    '& .MuiSelect-root': {
      padding: '10px',
      fontSize: '13.5px',
    },
  },
  role: {
    gridColumn: 1,
  },
  select: {
    '& .MuiInputLabel-formControl': {
      transform: 'none',
    },
  },
  selectOulined: {
    marginTop: '26px',
  },
  buttonsContainer: {
    '& button': {
      width: '100%',
      borderRadius: '10px',
      color: theme.palette.primary.white,
      backgroundColor: theme.palette.secondary.blue,
    },
  },
  users: {
    display: 'table-cell',
    textAlign: 'center',
    padding: '50px',
    '& svg': {
      width: '40px',
      height: '40px',
      color: theme.palette.primary.main,
    },
    '& h4': {
      color: theme.palette.primary.main,
      fontWeight: '200',
    },
  },
  header: {
    display: 'flex',
    paddingBottom: '20px',
  },
  underlined: {
    textDecoration: 'underline',
  },
  buttonSelected: {
    padding: '5px',
    '& .MuiButton-label': {
      fontSize: '16px',
      fontWeight: '800',
      color: theme.palette.custom.accentText,
      textDecoration: 'underline',
      textUnderlineOffset: '5px',
    },
  },
  button: {
    padding: '5px',
    '& .MuiButton-label': {
      fontSize: '16px',
      fontWeight: '800',
      color: theme.palette.custom.disabledText,
    },
  },
  tableHeader: {
    '& .Mui-checked': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
    '& .MuiCheckbox-indeterminate ': {
      color: theme.palette.secondary.blue,
      opacity: 0.5,
    },
  },
  success: {
    color: theme.palette.primary.success,
    borderColor: theme.palette.primary.success,
    borderWidth: '2px',
    borderRadius: '6px',
    backgroundColor: theme.palette.transparent.success,
  },
  warning: {
    color: theme.palette.primary.warning,
    borderColor: theme.palette.primary.warning,
    borderWidth: '2px',
    borderRadius: '6px',
    backgroundColor: theme.palette.transparent.warning,
  },
  processing: {
    color: theme.palette.primary.blue,
    borderColor: theme.palette.primary.blue,
    borderWidth: '2px',
    borderRadius: '6px',
  },
  error: {
    color: theme.palette.primary.error,
    borderColor: theme.palette.primary.error,
    borderWidth: '2px',
    borderRadius: '6px',
    backgroundColor: theme.palette.transparent.error,
  },
  layout: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  errorMessage: {
    color: theme.palette.custom.errorText,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    color: theme.palette.primary.main,
  },
  paperContainer: {
    '& .MuiPaper-root': {
      elevation: 3,
    },
  },
  modalToolbar: {
    paddingLeft: '0px',
    paddingRight: '0px',
  },
  modalTitle: {
    flexGrow: 1,
    paddingLeft: '69px',
  },
  icon: {
    '& svg': {
      color: theme.palette.primary.main,
    },
    '& svg:hover': {
      color: theme.palette.primary.blue,
    },
  },
  uploadIcon: {
    '& svg': {
      paddingTop: '11px',
      height: '50px',
      width: '100%',
      color: theme.palette.custom.iconAccent,
      margin: '0px',
    },
    '& svg:hover': {
      opacity: '0.8',
    },
  },
  projectName: {
    paddingLeft: '1%',
    marginLeft: '10px',
  },
  boxTitle: {
    flexGrow: 1,
  },
  imageTest: {
    height: '100%',
    width: '100%',
  },
  rejectAll: {
    backgroundColor: theme.palette.secondary.red,
  },
  aproveAndContinue: {
    backgroundColor: theme.palette.secondary.green,
  },
  modalForm: {
    width: '500px',
    minWidth: 0,
    maxWidth: 'calc(100vw - 32px)',
    minHeight: '150px',
    borderRadius: '12px',
    '& .MuiGrid-item': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .MuiButton-root': {
      height: '50px',
      width: '150px',
      maxWidth: '100%',
      color: theme.palette.primary.white,
      borderRadius: '30px',
      marginTop: '15%',
      marginBottom: 0,
    },
    '& .makeStyles-rejectSelected-53': {
      backgroundColor: theme.palette.secondary.yellow,
    },
    '& .makeStyles-rejectAll-54': {
      backgroundColor: theme.palette.secondary.red,
    },
    '& .makeStyles-aproveAndContinue-55': {
      backgroundColor: theme.palette.secondary.green,
    },
  },
  secondModalForm: {
    width: '500px',
    minWidth: 0,
    maxWidth: 'calc(100vw - 32px)',
    minHeight: '150px',
    borderRadius: '12px',
    '& .MuiButton-root': {
      height: '50px',
      width: '150px',
      maxWidth: '100%',
      color: theme.palette.primary.white,
      borderRadius: '30px',
      marginTop: '15%',
      marginBottom: 0,
    },
  },
  subheader: {
    paddingBottom: '5px',
    paddingTop: '10px',
    paddingLeft: '5px',
  },
  subDivider: {
    paddingBottom: '5px',
    paddingTop: '15px',
    paddingLeft: '5px',
    '& img': {
      paddingLeft: '10px',
    },
  },
  confirmModal: {
    paddingTop: '2%',
  },
  companyCard: {
    // '#eff3ff' -> `cardAccentBackground` ('#2C9DC910' over white), a sub-perceptual
    // shift in light mode; '#ddd' -> `hairline` ('#E0E0E0').
    backgroundColor: theme.palette.custom.cardAccentBackground,
    border: `1px solid ${theme.palette.custom.hairline}`,
    borderRadius: '8px',
    padding: '16px',
  },
  questionCard: {
    border: `1px solid ${theme.palette.custom.hairline}`,
    borderRadius: '8px',
    padding: '16px',
  },
  referenceImageButton: {
    position: 'relative',
    display: 'block',
    padding: '0px',
    lineHeight: 0,
    overflow: 'hidden',
    cursor: 'zoom-in',
    border: '1px solid #ddd',
    borderRadius: '6px',
    backgroundColor: theme.palette.primary.white,
    '&:hover': {
      borderColor: theme.palette.secondary.blue,
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.secondary.blue}`,
      outlineOffset: '2px',
    },
  },
  referenceImageThumb: {
    display: 'block',
    width: '70px',
    height: '70px',
    objectFit: 'cover',
  },
  referenceImageZoomBadge: {
    position: 'absolute',
    bottom: '2px',
    right: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '18px',
    height: '18px',
    borderRadius: '4px',
    color: theme.palette.primary.white,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
  },
  referenceImageTooltip: {
    maxWidth: 'none',
    padding: '6px',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
  },
  referenceImageTooltipImg: {
    display: 'block',
    width: 'auto',
    height: 'auto',
    // Vista previa grande al pasar el mouse, sin deformar la imagen.
    maxWidth: '52vw',
    maxHeight: '72vh',
    borderRadius: '4px',
  },
  referenceImageDialogPaper: {
    width: '96vw',
    maxWidth: '96vw',
    height: '94vh',
    maxHeight: '94vh',
    margin: '0px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  referenceImageDialogBody: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000000',
  },
  referenceImageDialogError: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    textAlign: 'center',
    // El cuerpo del diálogo tiene fondo negro.
    color: theme.palette.primary.white,
  },
  referenceImageDialogImg: {
    display: 'block',
    width: '100%',
    height: '100%',
    // "contain" ocupa el máximo espacio disponible conservando la proporción.
    objectFit: 'contain',
  },
}));

export const StyledTabs = withStyles((theme) => ({
  indicator: {
    backgroundColor: theme.palette.secondary.blue,
  },
}))(Tabs);

export const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: '75px',
    textTransform: 'none',
    padding: '0px 8px',
    margin: '0px 10px',
    color: theme.palette.primary.gray,
  },
}))((props) => <Tab disableRipple {...props} />);

export default useStyles;
